// eslint-disable-next-line import/no-unresolved -- eslint-import-resolver-node doesn't support package.json "exports" subpaths
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const {
    NEWRELIC_ENABLED,
    NEWRELIC_ACCOUNT_ID,
    NEWRELIC_TRUST_KEY,
    NEWRELIC_AGENT_ID,
    NEWRELIC_LICENSE_KEY,
    NEWRELIC_APPLICATION_ID,
} = window.config;

if (NEWRELIC_ENABLED === true && NEWRELIC_LICENSE_KEY && NEWRELIC_APPLICATION_ID) {
    // eslint-disable-next-line no-new
    new BrowserAgent({
        init: {
            distributed_tracing: { enabled: false },
            privacy: { cookies_enabled: true },
            // Replay and traces can capture student data; keep off until reviewed.
            session_replay: { enabled: false },
            session_trace: { enabled: false },
        },
        info: {
            beacon: 'bam.nr-data.net',
            errorBeacon: 'bam.nr-data.net',
            licenseKey: NEWRELIC_LICENSE_KEY,
            applicationID: NEWRELIC_APPLICATION_ID,
            sa: 1,
        },
        loader_config: {
            accountID: NEWRELIC_ACCOUNT_ID,
            trustKey: NEWRELIC_TRUST_KEY || NEWRELIC_ACCOUNT_ID,
            agentID: NEWRELIC_AGENT_ID || NEWRELIC_APPLICATION_ID,
            licenseKey: NEWRELIC_LICENSE_KEY,
            applicationID: NEWRELIC_APPLICATION_ID,
        },
    });
}
